import { get } from "aws-amplify/api";
import { fetchAuthSession } from "aws-amplify/auth";

export async function getLeaderboards() {
	const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
	try {
		const restOperation = get({
			apiName: "igniteinsights",
			path: `/leaderboards`,
			options: {
				headers: {
					Authorization: authToken,
				},
			},
		});
		const response = await restOperation.response;
		const json = await response.body.json();
		return json;
	} catch (e) {
		console.log(e);
	}
}
